export const applicationRouteNames = {
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
  lookups: 'lookups',
  aggregate: 'aggregate',
  ingredients: 'ingredients',
  grades: 'grades',
  forecast: 'forecast',
  forecastList: 'list',
  forecastNew: 'new',
  forecastEdit: 'edit',
};
